module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/companies-section/companies-section.component.scss
// module id = ./web/modern/components/settings/companies-section/companies-section.component.scss
// module chunks = 0